import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { InfoTooltip } from '@/components/common/InfoTooltip';
import { BAR_COLORS } from '@/utils/chart-colors';

interface HardwareDistributionProps {
  hardwareVendors: Record<string, number>;
  selectedVendor?: string | null;
  onSelect?: (vendor: string | null) => void;
}

export function HardwareDistribution({
  hardwareVendors,
  selectedVendor,
  onSelect,
}: HardwareDistributionProps) {
  const data = Object.entries(hardwareVendors)
    .map(([name, value]) => ({ name, value }))
    .sort((a, b) => b.value - a.value);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="dls-flex dls-items-center dls-gap-1.5">
          Hardware
          <InfoTooltip text="Breakdown of Nodes by hardware vendor, detected from device details reported by each Node. Click a bar to filter the dashboard." />
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="dls-h-[250px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              layout="vertical"
              onClick={(state) => {
                if (onSelect && state?.activePayload?.[0]?.payload?.name) {
                  const clicked = state.activePayload[0].payload.name;
                  onSelect(clicked === selectedVendor ? null : clicked);
                }
              }}
            >
              <CartesianGrid strokeDasharray="3 3" horizontal={false} />
              <XAxis type="number" />
              <YAxis dataKey="name" type="category" width={120} fontSize={12} />
              <Tooltip
                formatter={(value: number) => [`${value} Nodes`, 'Count']}
                cursor={{ fill: 'rgba(0,0,0,0.05)', cursor: 'pointer' }}
              />
              <Bar
                dataKey="value"
                radius={[0, 4, 4, 0]}
                barSize={20}
                className={onSelect ? 'dls-cursor-pointer hover:dls-opacity-80' : ''}
              >
                {data.map((_, index) => (
                  <Cell key={`cell-${index}`} fill={BAR_COLORS[index % BAR_COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
